
import { SistemaMixin } from "@/modules/Application";
import TableApp from "@/components/Table/Table2";
import FilterFields from "@/components/FilterFields";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import Pencil from "vue-material-design-icons/Pencil.vue";
import swal from "sweetalert";
import { actionsStore } from "@/components/Table/actionsStore";

export default {
  name: "servicos",
  mixins: [SistemaMixin],
  components: {
    TableApp,
    FilterFields,
    TrashCanIcon,
    Pencil,
  },
  data() {
    return {
      actionsStore,
      filterFields: [
        {
          type: "text",
          label: "Descrição",
          field: "discriminacao",
        },
      ],
      fields: [
        {
          label: "Descrição",
          field: "discriminacao",
          type: "text",
          slot: true,
          width: '80%',
          sortable: true,
        },
        {
          label: "Valor",
          field: "valor",
          slot: true,
          sortable: true,
        },
        {
          label: "",
          field: "actions",
          sortable: false,
          width: "5%",
          slot: true,
        },
      ],
    }
  },
  created() {
  },
  methods: {
    async handleDeleteServico(servico) {
      this.$swal
        .fire({
          icon: "warning",
          title: "Excluir o serviço " + servico.discriminacao + "?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              this.$http.post('/servicos/delete', {
                id_servico: servico.id_servico,
              })
              this.$toast.success('Serviço excluído com sucesso!')
              this.actionsStore.updateTable = !this.actionsStore.updateTable;
            } catch (error) {
              console.log(error);
            }
          }
        });
    },
    async handleEditServico(data) {
      swal({
        title: "Deseja editar o serviço?",
        text: "Você ira ser direcionado para a pagina de edição aguarde...",
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }

        const responseTributacao = await this.$http.post("/tributacaoservico/find", {
          id_tributacao_servico: data.id_tributacao_servico,
        })

        await this.$http
          .post("/servicos/find", {
            id_servico: data.id_servico,
          })
          .then((response) => {
            swal.stopLoading();
            swal.close();
            this.$toast.info("Você será redirecionado agora");
            this.$router.push({
              name: "novoServicos",
              params: { servicoData: { ...response.data, id_servico: data.id_servico }, tributacaoData: { ...responseTributacao.data } },
            });
          })
          .catch(() => {
            swal.stopLoading();
            this.$toast.error("Erro ao solicitar o endpoint do serviço");
            swal.close();
          });
      });
    }
  },
  computed: {
    config() {
      return this.layoutConfig();
    },
  },
  mounted() {

  },
};
